module.exports = __webpack_public_path__ + "static/desktop/img/group-desginer.71fc2d2b.png";